import React, { useRef } from "react";
import { projects } from "../data/siteData";
import useScrollAnimation from "../hooks/useScrollAnimation";
import "./Projects.css";

export default function Projects() {
  const trackRef = useRef(null);

  const sectionRef = useScrollAnimation(({ gsap, ScrollTrigger, el }) => {
    const isDesktop = window.matchMedia("(min-width: 769px)").matches;
    if (!isDesktop || !trackRef.current) return;

    const track = trackRef.current;
    const scrollWidth = track.scrollWidth - el.offsetWidth;

    gsap.to(track, {
      x: -scrollWidth,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top top",
        end: () => `+=${scrollWidth}`,
        scrub: 0.6,
        pin: true,
        pinType: "transform",
        anticipatePin: 1,
        invalidateOnRefresh: true,
      },
    });
  }, []);

  return (
    <section id="projects" className="projects" ref={sectionRef}>
      <div className="projects__header container">
        <span className="eyebrow">Selected Work</span>
        <h2 className="projects__title">
          PROJECTS <span className="glow-text">IN THE SUN</span>
        </h2>
      </div>

      <div className="projects__track" ref={trackRef}>
        {projects.map((p, i) => (
          <article className="projects__card" key={p.id}>
            <div className="projects__card-image" />
            <div className="projects__card-meta">
              <span className="projects__card-number">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3>{p.type}</h3>
              <p>
                {p.location} — {p.capacity} — {p.year}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
